define('admin/teams/index',['jquery', 'plugins/http', 'knockout'], function ($, http, ko) {
    var viewmodel = function() {
        var self = this;

        self.teamsContent = ko.observable();
        self.usersContent = ko.observable();

        self.activate = function() {
            self.composeTeamsList();
            self.composeUsersList();
        };

        self.composeTeamsList = function () {
            self.teamsContent({ model: 'admin/teams/teams' });
        };

        self.composeUsersList = function () {
            self.usersContent({ model: 'admin/teams/users', activationData: [self.composeInviteUser, self.composeEditUser] });
        };

        self.composeInviteUser = function () {
            self.usersContent({ model: 'admin/teams/invite', activationData: [self.composeUsersList] });
        };

        self.composeEditUser = function (user) {
            self.usersContent({ model: 'admin/teams/edituser', activationData: [user,self.composeUsersList] });
        };
    };

    return viewmodel;
});

